/* Raso DA v9 — finitions : vidéo d'accueil adaptée à l'écran, boutons d'options sur la fiche produit. */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection && navigator.connection.saveData;

  /* --- Vidéo d'accueil : version légère sur mobile, rien si l'utilisateur limite les données ou les animations --- */
  document.querySelectorAll('video[data-src-small]').forEach((video) => {
    if (reducedMotion || saveData) return;
    const small = window.matchMedia('(max-width: 900px)').matches;
    video.src = small ? video.dataset.srcSmall : video.dataset.srcLarge;
    video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
    video.play().catch(() => {});
  });

  /* --- Fiche produit : les options se choisissent avec des boutons plutôt qu'une liste déroulante.
         Taille : pastilles rondes. Autres options (Modèle, Doublure…) : boutons texte.
         La couleur garde ses pastilles de couleur (rendues par main-product). --- */
  const select = document.querySelector('.product-form select[id^="Variant-"]');
  if (!select) return;
  const sizePattern = /taille|size|pointure/i;
  const colorPattern = /couleur|color|coloris/i;

  if (!document.getElementById('polish-options-style')) {
    const style = document.createElement('style');
    style.id = 'polish-options-style';
    style.textContent = '.polish-options .polish-size{width:auto;min-width:0;padding:0 18px;border-radius:999px;white-space:nowrap}.polish-options{margin-bottom:6px}';
    document.head.appendChild(style);
  }

  fetch(`${location.pathname.replace(/\/$/, '')}.js`)
    .then((response) => (response.ok ? response.json() : null))
    .then((product) => {
      if (!product || product.variants.length < 2) return;
      const names = product.options.map((option) => (typeof option === 'string' ? option : option.name));
      const sizeIndex = names.findIndex((name) => sizePattern.test(name));
      const hasColorSwatches = !!document.querySelector('[data-product-color-swatches]');
      /* Options à afficher en boutons texte : ni taille, ni couleur déjà en pastilles. */
      const textIndexes = names.map((name, index) => index).filter((index) => index !== sizeIndex
        && !(colorPattern.test(names[index]) && hasColorSwatches));
      const groups = [...textIndexes, ...(sizeIndex === -1 ? [] : [sizeIndex])];
      if (!groups.length) return;

      const optionOf = (variant, index) => variant.options[index];
      const variantById = (id) => product.variants.find((variant) => String(variant.id) === String(id));
      const valuesOf = (index) => [...new Set(product.variants.map((variant) => optionOf(variant, index)))];
      const label = document.querySelector(`label[for="${select.id}"]`);

      const fieldsets = groups.map((index) => {
        const fieldset = document.createElement('fieldset');
        fieldset.className = index === sizeIndex ? 'polish-sizes' : 'polish-sizes polish-options';
        fieldset.innerHTML = `<legend>${names[index].replace(/ de l.accessoire/i, '')}<strong data-polish-size-label></strong></legend><div class="polish-sizes__list"></div>`;
        select.before(fieldset);
        return { index, fieldset, list: fieldset.querySelector('.polish-sizes__list'), label: fieldset.querySelector('[data-polish-size-label]') };
      });
      select.classList.add('polish-variant-select-hidden');
      select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');
      if (label) label.classList.add('polish-variant-select-hidden');

      const first = variantById(select.value) || product.variants[0];
      let lastSize = sizeIndex === -1 ? null : optionOf(first, sizeIndex);

      function choose(variant) {
        if (!variant || String(select.value) === String(variant.id)) return;
        select.value = String(variant.id);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      /* Variante qui prend `value` pour l'option `index` en gardant au mieux les autres choix. */
      function findFor(current, index, value) {
        const others = names.map((_, i) => i).filter((i) => i !== index);
        const exact = product.variants.find((v) => optionOf(v, index) === value && others.every((i) => optionOf(v, i) === optionOf(current, i)));
        if (exact) return exact;
        const keepSize = sizeIndex !== -1 && index !== sizeIndex
          ? product.variants.find((v) => optionOf(v, index) === value && optionOf(v, sizeIndex) === lastSize && v.available)
          : null;
        return keepSize || product.variants.find((v) => optionOf(v, index) === value && v.available)
          || product.variants.find((v) => optionOf(v, index) === value);
      }

      function render() {
        const current = variantById(select.value);
        if (!current) return;
        fieldsets.forEach(({ index, list, label: valueLabel }) => {
          list.replaceChildren(...valuesOf(index).map((value) => {
            const match = findFor(current, index, value);
            const exact = product.variants.find((v) => optionOf(v, index) === value
              && names.every((_, i) => i === index || optionOf(v, i) === optionOf(current, i)));
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'polish-size';
            button.textContent = value;
            const selected = optionOf(current, index) === value;
            button.setAttribute('aria-pressed', selected ? 'true' : 'false');
            if (index === sizeIndex) {
              /* Tailles : seules celles qui existent pour le reste de la sélection. */
              if (!exact) button.hidden = true;
              else if (!exact.available) {
                button.disabled = !selected;
                button.title = 'Épuisé';
                if (selected) button.classList.add('is-soldout-selected');
              }
            } else if (match && !match.available && !selected) {
              button.title = 'Épuisé';
            }
            button.addEventListener('click', () => {
              if (index === sizeIndex) lastSize = value;
              choose(index === sizeIndex ? exact : match);
            });
            return button;
          }));
          valueLabel.textContent = `${optionOf(current, index)}${index === sizeIndex && !current.available ? ' · épuisé' : ''}`;
        });
        updateSticky(current);
      }

      function updateSticky(variant) {
        const small = document.querySelector('.r-sales-sticky small');
        const text = variant.options.join(' · ') + (variant.available ? '' : ' · épuisé');
        if (small && small.textContent !== text) small.textContent = text;
      }

      /* Quand on change une autre option, on garde la taille déjà choisie si elle existe. */
      function onVariantChange() {
        const current = variantById(select.value);
        if (!current) return;
        if (sizeIndex !== -1 && optionOf(current, sizeIndex) !== lastSize) {
          const keep = product.variants.find((v) => optionOf(v, sizeIndex) === lastSize
            && names.every((_, i) => i === sizeIndex || optionOf(v, i) === optionOf(current, i)));
          if (keep && keep.available) { choose(keep); return; }
          lastSize = optionOf(current, sizeIndex);
        }
        render();
      }
      select.addEventListener('change', onVariantChange);
      document.addEventListener('click', (event) => {
        if (event.target.closest('.product-color-swatch')) setTimeout(onVariantChange, 0);
      });

      render();
      /* La barre d'achat est gérée par un autre script : on garde son texte à jour s'il la recrée ou la réécrit. */
      new MutationObserver(() => {
        const current = variantById(select.value);
        if (current) updateSticky(current);
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    })
    .catch(() => {});
})();
